import { render } from "./Tour.vue?vue&type=template&id=2bfaa972&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import "./Tour.vue?vue&type=style&index=0&id=2bfaa972&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfaa972"]])

export default __exports__